import RISON from 'rison';

export default function (obj) {
  let params = [];
  let escape = RISON.quote;
  params.add = function (key, value) {
    if (typeof value === 'function') {
      value = value();
    }
    if (value === null) {
      value = '';
    }
    this.push(escape(key) + '=' + escape(value));
  };
  serialize(params, obj);
  return params.join('&').replace(/%20/g, '+');
};

function serialize (params, obj, scope) {
  let array = Array.isArray(obj);
  let plain = isPlainObject(obj);
  let hash;

  each(obj, (value, key) => {
    hash = isObject(value) || Array.isArray(value);

    if (scope) {
      key = scope + '[' + (plain || hash ? key : '') + ']';
    }

    if (!scope && array) {
      params.add(value.name, value.value);
    } else if (hash) {
      serialize(params, value, key);
    } else {
      params.add(key, value);
    }
  });
}

function each (obj, iterator) {
  let i, key;
  if (Array.isArray(obj)) {
    for (i = 0; i < obj.length; i++) {
      iterator.call(obj[i], obj[i], i);
    }
  } else if (isObject(obj)) {
    for (key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        iterator.call(obj[key], obj[key], key);
      }
    }
  }
  return obj;
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object';
}
function isPlainObject (obj) {
  return isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;
}



// WEBPACK FOOTER //
// ./src/services/urlParams.js